import { defineMessages } from 'react-intl';

export default defineMessages({
  pageTitle: {
    id: 'features.retrievePassword.pageTitle',
    defaultMessage: 'Recupera Password',
    description: 'Title of the retrieve password page',
  },
  pageSubtitle: {
    id: 'features.retrievePassword.pageSubtitle',
    defaultMessage: 'Seleziona da dove vuoi recuperare i dati',
    description: 'Subtitle of the retrieve password page',
  },
  backLink: {
    id: 'features.retrievePassword.backLink',
    defaultMessage: 'Indietro',
    description: 'Label link to come back',
  },
  labelFirstRadioButton: {
    id: 'features.retrievePassword.labelFirstradioButton',
    defaultMessage: 'Recupera Password via email',
    description: 'Label for first radio button',
  },
  labelSecondRadioButton: {
    id: 'features.retrievePassword.labelSecondRadioButton',
    defaultMessage: 'Recupera Password via cellulare',
    description: 'Label for second radio button',
  },
  labelUsernameInputText: {
    id: 'features.retrievePassword.labelUsernameInputText',
    // eslint-disable-next-line quotes
    defaultMessage: "Inserisci l'username utilizzato per la registrazione",
    description: 'Label for email input text',
  },
  placeholderUsernameInputText: {
    id: 'features.retrievePassword.placeholderEmailInputText',
    // eslint-disable-next-line quotes
    defaultMessage: "Inserisci l'username",
    description: 'Placeholder for email input text',
  },
  retrievePasswordButton: {
    id: 'features.retrievePassword.retrievePasswordButton',
    defaultMessage: 'Conferma',
    description: 'Label of the retrieve password button',
  },
  disclaimer: {
    id: 'features.retrievePassword.disclaimer',
    defaultMessage: 'Torna alla ',
  },
  successMessageRetrievePasswordByEmail: {
    id: 'features.retrievePassword.successMessageRetrievePasswordByEmail',
    defaultMessage:
      'Recupero password completato. Controlla di aver ricevuto l’email per procedere',
    description: 'Success message retrieve password by email',
  },
  successMessageRetrievePasswordBySMS: {
    id: 'features.retrievePassword.successMessageRetrievePasswordBySMS',
    defaultMessage:
      'Recupero password completato. Controlla di aver ricevuto l’SMS per procedere',
    description: 'Success message retrieve password by sms',
  },
  successDialogRetrievePasswordButtonLabel: {
    id: 'features.retrievePassword.successDialogRetrievePasswordButtonLabel',
    defaultMessage: 'Chiudi',
    description: 'Success dialog retrieve password button label',
  },
  errorTooManyRequests: {
    id: 'features.retrievePassword.errorTooManyRequests',
    defaultMessage:
      'Non è possibile procedere con il recupero della password: hai superato il numero massimo di richieste. Riprova più tardi.',
    description: 'Error message when too many password recoveries were requested (HTTP 429)',
  },
});
